import { render } from "./App.vue?vue&type=template&id=b1cb5abc"
const script = {}

import "../public/css/site.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__